import React from 'react';
import {Button} from "antd";
import './style.scss'
import {MenuOutlined} from "@ant-design/icons";
import {useAppDispatch} from "../../../ducks/hooks";
import {toggleMobileMenu} from "../../../ducks/app";
import { AuthUser } from 'aws-amplify/auth';

interface GreetingProps {
  user?: AuthUser;
  signOut: ((data?: any | undefined) => void) | undefined;
  isMobile: boolean;
}

const Greeting: React.FC<GreetingProps> = ({user, signOut, isMobile}) => {
  const dispatch = useAppDispatch();
  const toggleMenu = () => dispatch(toggleMobileMenu());
  return (
    <div className="greeting ">
      {isMobile &&
      <Button icon={<MenuOutlined />} onClick={toggleMenu} />
      }
      {user && <span style={{flexGrow: 2, textAlign: "right"}}>Hello {user.username}</span>}
      {signOut && <Button
        id="signOut"
        onClick={signOut}
        size="large"
        type="primary"
      >Sign Out</Button>}
    </div>
  );
}

export default Greeting;